export const allClasses = (state = [false,[]], action) => {
  if (action.type === "SET_CLASSES") {
    return [true,action.classes]
  }
  return state
}
